import React, { useState, useEffect, useContext } from 'react';
import { Container, Stack, Grid, Chip, Divider, Box, FormControl, TextField, Button, Card, CardContent, Typography, CircularProgress, IconButton, Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions } from "@mui/material";
import axios from 'axios';
import { ContextSession } from "../../../services/ContextSession";
import ManageAccountsIcon from '@mui/icons-material/ManageAccounts';

function ActualizarDatos() {
    let sessi = useContext(ContextSession);
    const [valor, setValor] = useState('');
    const [datos, setDatos] = useState(null);
    const [error, setError] = useState('');
    const [visible, setVisible] = useState(false);
    const [loading, setLoading] = useState(false);
    const [identidadConsultada, setIdentidadConsultada] = useState('');
    const [dialogOpen, setDialogOpen] = useState(false);
    const [dialogMessage, setDialogMessage] = useState('');

    const handleChange = (event) => {
        const valorIngresado = event.target.value;
        const regex = /^[0-9]+$/; // Solo números

        if (regex.test(valorIngresado)) {
            setValor(valorIngresado);
        } else {
            setValor(''); // o puedes mostrar un error
        }
    };

    const consultarAPI = async () => {
        setLoading(true); // Comienza la carga
        try {
            const response = await axios.post('https://bei360.injupemp.gob.hn:8444/api/datos/biometria', {
                dni: valor
            });

            if (response.data.error) {
                setError(response.data.error);
                setDatos(null);
            } else {
                const informacion = response.data.informacion;

                // Validar que informacion no sea null o undefined
                if (!informacion) {
                    setError('No se recibió información válida de la API');
                    setDatos(null);
                } else {
                    const nuevosDatos = {
                        nombre: `${informacion[0]?.split(': ')[1] ?? ''} ${informacion[1]?.split(': ')[1] ?? ''} ${informacion[2]?.split(': ')[1] ?? ''} ${informacion[3]?.split(': ')[1] ?? ''}`,
                        nacimiento: informacion[4]?.split(': ')[1] ?? '',
                        direccion: informacion[5]?.split(': ')[1] ?? '',
                        telefono: informacion[7]?.split(': ')[1] ?? '',
                        telefonotrabajo: informacion[8]?.split(': ')[1] ?? '',
                        correo: informacion[9]?.split(': ')[1] ?? '',
                        direcciontrabajo: informacion[10]?.split(': ')[1] ?? '',
                        area: informacion[11]?.split(': ')[1] ?? '',
                        fechacreacion: informacion[12]?.split(': ')[1] ?? '',
                        fecharegistro: informacion[13]?.split(': ')[1] ?? '',
                        departamento: informacion[14]?.split(': ')[1] ?? '',
                        municipio: informacion[15]?.split(': ')[1] ?? '',
                        colonia: informacion[16]?.split(': ')[1] ?? '',
                        estadocivil: informacion[17]?.split(': ')[1] ?? '',
                        nacionalidad: informacion[19]?.split(': ')[1] ?? '',
                        sexo: informacion[18]?.split(': ')[1] ?? '',
                        pais: informacion[20]?.split(': ')[1] ?? '',
                        profesion: informacion[21]?.split(': ')[1] ?? ''
                    };

                    setDatos(nuevosDatos);
                    setIdentidadConsultada(valor);
                    setError('');
                }
            }
            setVisible(true);
        } catch (error) {
            setError('No se encontró información válida para el DNI proporcionado');
            setVisible(true);
        }
        setLoading(false); // Termina la carga
    };

    const actualizarDatos = async () => {
        if (!datos || !datos.correo || !datos.telefono) {
            setDialogMessage('Faltan datos para actualizar.');
            setDialogOpen(true);
            return;
        }
    
        const token = sessi.sessionData?.token;
    
        if (!token) {
            setDialogMessage('No se encontró el token de autenticación.');
            setDialogOpen(true);
            return;
        }
    
        const formData = new FormData();
        formData.append('dni', identidadConsultada);  // El DNI consultado
        formData.append('correo', datos.correo);     // El correo consultado
        formData.append('telefono', datos.telefono); // El teléfono consultado
    
        try {
            setLoading(true);
    
            const response = await axios.post('https://bei360.injupemp.gob.hn:8444/api/part/update/', formData, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'multipart/form-data'
                }
            });
    
            // Imprimir la respuesta completa para depurar
            console.log('Respuesta de la API:', response.data);
    
            // Ahora comprobamos correctamente la respuesta
            if (response.data && response.data.status === 'success') {
                setDialogMessage('Datos actualizados con éxito.');
            } else {
                // Si no es un éxito, mostramos el mensaje de error desde la respuesta
                setDialogMessage(response.data.message || 'Error desconocido al actualizar los datos.');
            }
        } catch (error) {
            // Mostrar error detallado
            console.error('Error al actualizar datos:', error);
            setDialogMessage('Hubo un error al intentar actualizar los datos.');
        } finally {
            setDialogOpen(true);
            setLoading(false);
        }
    };
    

    return (
        <>
            <Container>
                <Card sx={{ maxWidth: 600, margin: 'auto', padding: 2, borderRadius: 2, boxShadow: 3, marginTop: 5 }}>
                    <CardContent>
                        <Stack direction="row" spacing={2} alignItems="center" justifyContent="center" sx={{ marginBottom: 3 }}>
                            <ManageAccountsIcon sx={{ fontSize: 50 }} />
                            <Typography variant="h5" component="h2" fontWeight="bold">
                                Actualizar Datos De Usuario
                            </Typography>
                        </Stack>

                        <Stack direction="column" spacing={3} alignItems="center" sx={{ marginTop: 2 }}>
                            {/* Divider con Chip arriba del TextField */}
                            <Divider sx={{ width: '100%' }}>
                                <Chip label="INGRESE EL NÚMERO DE IDENTIDAD DEL USUARIO" size="medium" sx={{ fontWeight: 'bold' }} />
                            </Divider>

                            {/* Stack para el formulario y el botón */}
                            <Stack direction="row" spacing={3} justifyContent="center" alignItems="center">
                                <FormControl sx={{ width: 250 }}>
                                    <TextField
                                        id="NumeroIdentidad"
                                        label="Número de Identidad"
                                        placeholder="Identidad sin espacios ni guiones"
                                        variant="filled"
                                        value={valor}
                                        onChange={handleChange}
                                        inputProps={{ maxLength: 13 }}
                                        fullWidth
                                    />
                                </FormControl>

                                <Button
                                    variant="contained"
                                    sx={{
                                        backgroundColor: '#AD8401',
                                        '&:hover': {
                                            backgroundColor: '#19438C',
                                            color: 'white',
                                        },
                                    }}
                                    onClick={consultarAPI}
                                    disabled={valor.length !== 13} // Deshabilitar si no tiene 13 dígitos
                                >
                                    Consultar
                                </Button>
                            </Stack>
                        </Stack>
                    </CardContent>
                </Card>

                {loading && (
                    <Box display="flex" justifyContent="center" marginTop={2}>
                        <CircularProgress />
                    </Box>
                )}

                {visible && (
                    <>
                        <Divider style={{ marginTop: 20 }}>
                            <Chip
                                label="DATOS DEL ENROLAMIENTO"
                                size="small"
                                sx={{ fontWeight: 'bold' }} // Aplica negrita al texto del Chip
                            />
                        </Divider>

                        <div id="my-container">
                            <Box marginTop={2} boxShadow={3}>
                                <Card variant='elevation'>
                                    <CardContent>
                                        {error ? (
                                            <>
                                                <Box style={{ display: 'flex', alignItems: 'center' }}>
                                                    <img src={process.env.PUBLIC_URL + '/error.jpg'} alt="Error" style={{ marginRight: 10, width: 130, height: 130 }} />
                                                    <Typography color="error" style={{ flexGrow: 1, textAlign: 'center' }}>{error}</Typography>
                                                </Box>
                                            </>
                                        ) : (
                                            <>
                                                <Stack direction="row">
                                                    <Grid container spacing={1}>
                                                        <FormControl sx={{ m: 1, flexGrow: 2 }}>
                                                            <TextField
                                                                id="nombre"
                                                                label="Nombre Completo"
                                                                variant="filled"
                                                                InputProps={{ readOnly: true }}
                                                                size="small"
                                                                value={datos.nombre}
                                                            />
                                                        </FormControl>
                                                        <FormControl sx={{ m: 1, flexGrow: 2 }}>
                                                            <TextField
                                                                id="telefono"
                                                                label="Teléfono Móvil"
                                                                variant="filled"
                                                                InputProps={{ readOnly: true }}
                                                                size="small"
                                                                value={datos.telefono}
                                                            />
                                                        </FormControl>
                                                        <FormControl sx={{ m: 1, flexGrow: 1 }}>
                                                            <TextField
                                                                id="correo"
                                                                label="Correo"
                                                                variant="filled"
                                                                InputProps={{ readOnly: true }}
                                                                size="small"
                                                                value={datos.correo}
                                                            />
                                                        </FormControl>
                                                    </Grid>
                                                </Stack>
                                            </>
                                        )}
                                    </CardContent>
                                </Card>
                            </Box>

                            <Box marginTop={2} textAlign="center">
                                <Button
                                    variant="contained"
                                    sx={{
                                        backgroundColor: '#AD8401',
                                        '&:hover': {
                                            backgroundColor: '#19438C',
                                            color: 'white'
                                        },
                                    }}
                                    onClick={actualizarDatos} // Llama a la función para actualizar los datos
                                >
                                    Actualizar Datos
                                </Button>
                            </Box>
                        </div>
                    </>
                )}

                <Dialog open={dialogOpen} onClose={() => setDialogOpen(false)}>
                    <DialogTitle>Información</DialogTitle>
                    <DialogContent>
                        <DialogContentText>{dialogMessage}</DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={() => setDialogOpen(false)} style={{
                            backgroundColor: '#72D2DA',
                            borderColor: '#72D2DA',
                            color: '#fff',
                            fontWeight: 'bold'
                        }}>Cerrar</Button>
                    </DialogActions>
                </Dialog>

            </Container>
        </>
    );
}

export default ActualizarDatos;
